<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="text-center mb-8">
        <span
          class="text-h7"
          :class="{ 'neutral--text': !$vuetify.theme.dark }"
        >{{ subtitle }}</span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col
        class="pt-0"
        v-for="(item, index) in cardData"
        :key="`card_data__${index}`"
      >
        <CreateVideoOptionCard
          type="subtitle"
          :title="item.title"
          :description="item.description"
          :actionBtnText="item.actionBtnText"
          @action="item.action"
          :isAi="item.isAi"
          :minHeight="minHeight" 
          :imgSource="item.imgSource"
          :isBeta="item.isBeta"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CreateVideoOptionCard from '../CreateVideoOptionCard.vue'

export default {
  name: 'DefaultInitialState',
  components: { CreateVideoOptionCard },
  props: {
    cardData: {
      type: Array,
      required: true,
      default: () => [
        {
          title: 'upload',
          description: 'description',
          actionBtnText: 'action',
          action: () => ({}),
          isAi: true,
          imgSource: require('@/assets/upload.svg'),
        },
      ],
    },
    subtitle: {
      type: String,
      default: 'subtitle',
    },
  },
  data() {
    return {
      minHeight: 425 
    }
  },
  mounted() {
    this.updateMinHeight()
    window.addEventListener('resize', this.updateMinHeight)
  },
  methods: {
    updateMinHeight() {
      if (window.innerHeight >= 768) {
        this.minHeight = 425
      } if (window.innerHeight < 768 && window.innerHeight >= 630) {
        this.minHeight = 370
      }
      if (window.innerHeight < 630){
        this.minHeight = 320
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMinHeight)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style>
